
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_tenants/[tenant]",
      function () {
        return require("private-next-pages/_tenants/[tenant]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_tenants/[tenant]"])
      });
    }
  